/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Search, breakpoints } from '@coursera/cds-core';

type Props = {
  placeholder: string;
  value: string;
  id?: string;
  dataTestId?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  onChange: (value: string) => void;
  onClear?: () => void;
  ref?: React.RefObject<HTMLInputElement>;
  disabled?: boolean;
  autoComplete?: string;
  ariaLabel?: string;
};

const styles = {
  searchContainer: css`
    width: 600px;
    margin: 0 auto;
    ${breakpoints.down('xs')} {
      width: 100%;
    }

    svg {
      width: 20px;
      height: 20px;
      color: var(--cds-color-interactive-primary);
    }

    .cds-input-root {
      border-radius: 100px;
    }
  `,
};

const OnboardingSearch = ({ ariaLabel, dataTestId, ...props }: Props) => {
  return (
    <Search
      {...props}
      css={styles.searchContainer}
      hideSearchButton
      onSearch={() => {}}
      fullWidth
      aria-label={ariaLabel}
      data-testid={dataTestId}
    />
  );
};

export default OnboardingSearch;
